import "./Loading.scss"; // Make sure to create this CSS file in the same directory

const Loading = ({ size = "big" }) => (
  <div className={`loading-container ${size}`}>
    <div className="loading-spinner"></div>
  </div>
);

export default Loading;
